/* tslint:disable */
/* eslint-disable */
/**
 * RentalWorksStorefront API v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

export interface FwStandardBusinessLogicFwBusinessLogic {
    'AuditNote'?: string | null;
    'RecordTitle'?: string | null;
    'UrlIdentifier'?: any | null;
    '_Fields'?: Array<FwStandardBusinessLogicFwBusinessLogicFieldDefinition> | null;
    '_Custom'?: Array<FwStandardDataFwCustomValue> | null;
    '_DefaultFieldAttributes'?: Array<FwStandardDataFwDefaultAttribute> | null;
    '_Original'?: FwStandardBusinessLogicFwBusinessLogic;
    '_Translation'?: Array<FwStandardDataFwTranslatedValue> | null;
    '_HasImport'?: boolean;
    '_HasDocuments'?: boolean;
    'CreatedByUserId'?: string | null;
    'CreatedByUserName'?: string | null;
    'CreatedDateTime'?: string | null;
    'ModifiedByUserId'?: string | null;
    'ModifiedByUserName'?: string | null;
    'ModifiedDateTime'?: string | null;
}
export interface FwStandardBusinessLogicFwBusinessLogicFieldDefinition {
    'Name'?: string | null;
    'DataType'?: FwStandardSqlServerFwDataTypes;
    'ExcelOptions'?: FwStandardSqlServerAttributesFwExcelOptions;
    'MaxLength'?: number;
    'IsRequired'?: boolean;
    'IsPrimaryKey'?: boolean;
    'IsReadOnly'?: boolean;
    'DisplayFieldName'?: string | null;
    'AllowedValues'?: string | null;
    'TemplateSequence'?: number;
    'IsEmail'?: boolean;
}


export interface FwStandardDataFwCustomValue {
    'ModuleName'?: string | null;
    'FieldName'?: string | null;
    'FieldValue'?: string | null;
    'FieldType'?: string | null;
    'ValidationModule'?: string | null;
    'ValidationFieldName'?: string | null;
    'ValidationFieldId'?: string | null;
    'ListFieldAllowedValues'?: string | null;
}
export interface FwStandardDataFwDefaultAttribute {
    'FieldName'?: string | null;
    'AttributeName'?: string | null;
    'DefaultValue'?: string | null;
}
export interface FwStandardDataFwTranslatedValue {
    'FieldName'?: string | null;
    'TranslatedValue'?: string | null;
    'UntranslatedValue'?: string | null;
    'IsTranslated'?: boolean;
    'UserIsTranslating'?: boolean;
}
export interface FwStandardModelsFwApiException {
    'StatusCode'?: number;
    'Message'?: string;
    'StackTrace'?: string;
}
export interface FwStandardModelsFwQueryFilter {
    /**
     * The DataField name to filter on.
     */
    'Field': string;
    /**
     * Comparison operator: = (equals), <> (not equals)
     */
    'Op': string;
    /**
     * The value of the DataField to filter on.
     */
    'Value'?: string | null;
}
export interface FwStandardModelsFwQueryResponseStorefrontOrderDto {
    'Items'?: Array<StorefrontOrderDto> | null;
    'PageNo'?: number;
    'PageSize'?: number;
    'TotalItems'?: number;
    'Sort'?: string | null;
}
export interface FwStandardModelsFwQueryResponseWebApiModulesIntegrationsStorefrontStorefrontProductLoader {
    'Items'?: Array<WebApiModulesIntegrationsStorefrontStorefrontProductL> | null;
    'PageNo'?: number;
    'PageSize'?: number;
    'TotalItems'?: number;
    'Sort'?: string | null;
}

export const FwStandardSqlServerAttributesFwExcelOptions = {
    Required: 'Required',
    Recommended: 'Recommended',
    Optional: 'Optional',
    Omit: 'Omit',
    None: 'None'
} as const;

export type FwStandardSqlServerAttributesFwExcelOptions = typeof FwStandardSqlServerAttributesFwExcelOptions[keyof typeof FwStandardSqlServerAttributesFwExcelOptions];



export const FwStandardSqlServerFwDataTypes = {
    Text: 'Text',
    NonTrimmableText: 'NonTrimmableText',
    Date: 'Date',
    Time: 'Time',
    DateTime: 'DateTime',
    DateTimeOffset: 'DateTimeOffset',
    CreditCardExpirationDate: 'CreditCardExpirationDate',
    Decimal: 'Decimal',
    DecimalStringNoTrailingZeros: 'DecimalStringNoTrailingZeros',
    DecimalString1Digit: 'DecimalString1Digit',
    DecimalString2Digits: 'DecimalString2Digits',
    DecimalString3Digits: 'DecimalString3Digits',
    DecimalString4Digits: 'DecimalString4Digits',
    DecimalString8Digits: 'DecimalString8Digits',
    Boolean: 'Boolean',
    CurrencyString: 'CurrencyString',
    CurrencyStringNoDollarSign: 'CurrencyStringNoDollarSign',
    CurrencyStringNoDollarSignNoDecimalPlaces: 'CurrencyStringNoDollarSignNoDecimalPlaces',
    PhoneUs: 'PhoneUS',
    ZipcodeUs: 'ZipcodeUS',
    PercentageWholeNumber: 'PercentageWholeNumber',
    Percentage2Digits: 'Percentage2Digits',
    Percentage4Digits: 'Percentage4Digits',
    OleToHtmlColor: 'OleToHtmlColor',
    Integer: 'Integer',
    JpgDataUrl: 'JpgDataUrl',
    UtcDateTime: 'UTCDateTime',
    Email: 'Email'
} as const;

export type FwStandardSqlServerFwDataTypes = typeof FwStandardSqlServerFwDataTypes[keyof typeof FwStandardSqlServerFwDataTypes];


export interface InventoryAvailabilityCalendarDateDto {
    'Available'?: number | null;
    'Day'?: string;
}
export interface InventoryAvailabilityCalendarEventDto {
    'start'?: string | null;
    'end'?: string | null;
    'text'?: string | null;
    'backColor'?: string | null;
    'textColor'?: string | null;
    'id'?: string | null;
}
export interface InventoryAvailabilityCalendarResponseDto {
    'Dates'?: Array<InventoryAvailabilityCalendarDateDto> | null;
    'InventoryAvailabilityCalendarEvents'?: Array<InventoryAvailabilityCalendarEventDto> | null;
}
export interface ShoppingCartItemDto {
    'inventoryId'?: string | null;
    'product'?: WebApiModulesIntegrationsStorefrontStorefrontProductL;
    'qty'?: number;
    'packageItemQtys'?: { [key: string]: number | null; } | null;
}
export interface StorefrontHolidayDto {
    'Date'?: string | null;
    'Name'?: string | null;
}
export interface StorefrontOrderDto {
    'OrderId'?: string | null;
    'OrderDate'?: string | null;
    'OrderType'?: string | null;
    'OrderNumber'?: string | null;
    'Description'?: string | null;
    'DealId'?: string | null;
    'Deal'?: string | null;
    'OrderTotal'?: string | null;
    'EstimatedStart'?: string | null;
    'EstimatedStop'?: string | null;
    'Status'?: string | null;
    'Warehouse'?: string | null;
}
export interface StorefrontPackageItem {
    'Images'?: Array<WebApiModulesIntegrationsStorefrontProductImage> | null;
    'ProductId'?: number;
    'InventoryPackageInventoryId'?: string | null;
    'ICode'?: string | null;
    'Description'?: string | null;
    'InventoryId'?: string | null;
    'IsPrimary'?: boolean;
    'DefaultQuantity'?: number | null;
    'DefaultQuantityColor'?: string | null;
    'IsOption'?: boolean;
    'Charge'?: boolean | null;
    'NoChargePrint'?: boolean | null;
    'IsRequired'?: boolean | null;
    'OptionColor'?: string | null;
    'ItemClass'?: string | null;
    'ItemTrackedBy'?: string | null;
    'AvailFor'?: string | null;
    'AvailFrom'?: string | null;
    'OrderBy'?: number | null;
    'ItemColor'?: string | null;
    'IsNestedComplete'?: string | null;
    'Inactive'?: string | null;
    'WarehouseId'?: string | null;
    'ParentId'?: string | null;
    'PackageItemClass'?: string | null;
    'ItemNonDiscountable'?: string | null;
    'PrimaryInventoryId'?: string | null;
    'UnitId'?: string | null;
    'PackageId'?: string | null;
    'Availability'?: WebApiModulesIntegrationsStorefrontProductAvailability;
    'DailyRate'?: number | null;
    'WeeklyRate'?: number | null;
    'MonthlyRate'?: number | null;
    'DailyExtended'?: number | null;
    'WeeklyExtended'?: number | null;
    'MonthlyExtended'?: number | null;
    'SalesPrice'?: number | null;
    'Retail'?: number | null;
    'CurrencyId'?: string | null;
    'CurrencyCode'?: string | null;
    'CurrencySymbol'?: string | null;
    'DateStamp'?: string | null;
}
export interface WebApiModulesAccountServicesJwtAzureADRequest {
    'Email'?: string | null;
    'Token'?: string | null;
    'Tenant'?: string | null;
    'Audience'?: string | null;
    'Issuer'?: string | null;
}
export interface WebApiModulesIntegrationsPortalAuthSvcLoginResponseDto {
    'FullName'?: string | null;
    'Email'?: string | null;
    'DealId'?: string | null;
    'Deal'?: string | null;
    'HasStorefront'?: boolean;
    'HasPortal'?: boolean;
    'CustomerId'?: string | null;
    'Customer'?: string | null;
}
export interface WebApiModulesIntegrationsPortalServicesPortalSvcDtoDealResponseDto {
    'DealId'?: string | null;
    'Deal'?: string | null;
    'CustomerId'?: string | null;
    'Customer'?: string | null;
}
export interface WebApiModulesIntegrationsStorefrontContactRegistrationRequest {
    'Language'?: string | null;
    'FirstName': string;
    'LastName': string;
    'Phone'?: string | null;
    'Email': string;
    'StudentId'?: string | null;
}
export interface WebApiModulesIntegrationsStorefrontContactRegistrationResponse {
    'Success'?: boolean;
}
export interface WebApiModulesIntegrationsStorefrontDealModel {
    'DealId'?: string | null;
    'Deal'?: string | null;
}
export interface WebApiModulesIntegrationsStorefrontGetProductWarehouseDetailsResponse {
    'Availability'?: WebApiModulesIntegrationsStorefrontProductAvailability;
    'DailyRate'?: number;
    'WeeklyRate'?: number;
    'MonthlyRate'?: number;
    'CurrencySymbol'?: string | null;
    'CurrencyCode'?: string | null;
}
export interface WebApiModulesIntegrationsStorefrontLocationModel {
    'LocationId'?: string | null;
    'Location'?: string | null;
    'WarehouseId'?: string | null;
    'Warehouse'?: string | null;
}
export interface WebApiModulesIntegrationsStorefrontLoginRequest {
    'Email': string;
    'Password': string;
}
export interface WebApiModulesIntegrationsStorefrontProductAvailability {
    'TotalIn'?: number;
    'Total'?: number;
}
export interface WebApiModulesIntegrationsStorefrontProductCategory {
    'Id'?: string | null;
    'Name'?: string | null;
    'UrlName'?: string | null;
    'LinkUrl'?: string | null;
    'SubCategories'?: Array<WebApiModulesIntegrationsStorefrontProductSubCategory> | null;
}
export interface WebApiModulesIntegrationsStorefrontProductDepartment {
    'Id'?: string | null;
    'Name'?: string | null;
    'UrlName'?: string | null;
    'Categories'?: Array<WebApiModulesIntegrationsStorefrontProductCategory> | null;
}
export interface WebApiModulesIntegrationsStorefrontProductImage {
    'Id'?: string | null;
    'Url'?: string | null;
}
export interface WebApiModulesIntegrationsStorefrontProductSubCategory {
    'Id'?: string | null;
    'Name'?: string | null;
    'UrlName'?: string | null;
    'LinkUrl'?: string | null;
}
export interface WebApiModulesIntegrationsStorefrontQuoteRequest {
    'WebCatalogId'?: string | null;
    'Language'?: string | null;
    'Locale'?: string | null;
    'DepartmentId': string;
    'LocationId': string;
    'WarehouseId': string;
    'DealId'?: string | null;
    'QuoteDescription'?: string | null;
    'JobName'?: string | null;
    'StartDate': string;
    'StartTime'?: string | null;
    'StopDate': string;
    'StopTime'?: string | null;
    'Notes'?: string | null;
    'Items': Array<WebApiModulesIntegrationsStorefrontQuoteRequestItem>;
}
export interface WebApiModulesIntegrationsStorefrontQuoteRequestItem {
    'InventoryId': string;
    'WebCatalogId': string;
    'Qty': number;
    'PackageItems'?: Array<WebApiModulesIntegrationsStorefrontQuoteRequestPackageItem> | null;
}
export interface WebApiModulesIntegrationsStorefrontQuoteRequestPackageItem {
    'InventoryId': string;
    'InventoryPackageInventoryId': string;
    'Qty': number;
}
export interface WebApiModulesIntegrationsStorefrontResetPasswordFromEmailRequest {
    'Email': string;
    'TemporaryPassword': string;
    'NewPassword': string;
}
export interface WebApiModulesIntegrationsStorefrontSendInquiryEmailRequest {
    'CatalogProductId': string;
    'WarehouseId': string;
    'LocationId': string;
    'FirstName': string;
    'LastName': string;
    'Phone': string;
    'Email': string;
    'Message': string;
}
export interface WebApiModulesIntegrationsStorefrontSendInquiryEmailResponse {
    'Success'?: boolean;
    'FailureMessage'?: string | null;
}
export interface WebApiModulesIntegrationsStorefrontSendResetPasswordEmailRequest {
    'EmailTo': string;
    'Language'?: string | null;
}
export interface WebApiModulesIntegrationsStorefrontStorefrontProductL {
    '_Custom'?: Array<FwStandardDataFwCustomValue> | null;
    '_DefaultFieldAttributes'?: Array<FwStandardDataFwDefaultAttribute> | null;
    '_Translation'?: Array<FwStandardDataFwTranslatedValue> | null;
    '_HasImport'?: boolean | null;
    '_HasDocuments'?: boolean | null;
    'Id'?: number;
    'WarehouseId'?: string | null;
    'InventoryId'?: string | null;
    'InventoryNo'?: string | null;
    'ItemName'?: string | null;
    'Keywords'?: string | null;
    'Tags'?: string | null;
    'Barcodes'?: string | null;
    'ItemUrlName'?: string | null;
    'DetailedDescription'?: string | null;
    'TechnicalNotes'?: string | null;
    'Classification'?: string | null;
    'AvailableFor'?: string | null;
    'Owned'?: number;
    'InventoryTypeOrderBy'?: string | null;
    'CategoryOrderBy'?: string | null;
    'SubCategoryOrderBy'?: string | null;
    'MasterOrderBy'?: string | null;
    'Availability'?: WebApiModulesIntegrationsStorefrontProductAvailability;
    'WarehouseSpecific'?: boolean | null;
    'PackagePrice'?: string | null;
    'DailyRate'?: number | null;
    'WeeklyRate'?: number | null;
    'MonthlyRate'?: number | null;
    'SalesPrice'?: number | null;
    'CurrencySymbol'?: string | null;
    'CurrencyCode'?: string | null;
    'PackageItems'?: Array<StorefrontPackageItem> | null;
    'Manufacturer'?: string | null;
    'ManufacturerPartNumber'?: string | null;
    'ManufacturerUrl'?: string | null;
    'UnitValue'?: number | null;
    'ReplacementCost'?: number | null;
    'ShipWeightLbs'?: number | null;
    'ShipWeightOz'?: number | null;
    'Images'?: Array<WebApiModulesIntegrationsStorefrontProductImage> | null;
    'WebCatalogId'?: string | null;
    'WebCatalog'?: string | null;
    'WebCatalogUrlName'?: string | null;
    'InventoryDepartmentId'?: string | null;
    'InventoryDepartment'?: string | null;
    'InventoryDepartmentUrlName'?: string | null;
    'CategoryId'?: string | null;
    'Category'?: string | null;
    'CategoryUrlName'?: string | null;
    'SubCategoryId'?: string | null;
    'SubCategory'?: string | null;
    'SubCategoryUrlName'?: string | null;
    '_Original'?: FwStandardBusinessLogicFwBusinessLogic;
    'CreatedByUserId'?: string | null;
    'CreatedByUserName'?: string | null;
    'CreatedDateTime'?: string | null;
    'ModifiedByUserId'?: string | null;
    'ModifiedByUserName'?: string | null;
    'ModifiedDateTime'?: string | null;
}
export interface WebApiModulesIntegrationsStorefrontStorefrontProgress {
    'LastUpdated'?: string;
    'Failed'?: boolean;
    'FailureMessage'?: string | null;
    'FailureStackTrace'?: string | null;
    'SessionId'?: string | null;
    'Caption'?: string | null;
    'CurrentStep'?: number | null;
    'TotalSteps'?: number | null;
    'PercentComplete'?: number | null;
}
export interface WebApiModulesIntegrationsStorefrontStorefrontSettings {
    'IsStorefrontEnabled'?: boolean | null;
    'IsAnonymousAccessEnabled'?: boolean | null;
    'RegisterEnabled'?: boolean | null;
    'SeparateQuoteRequestsByCatalog'?: boolean | null;
    'MakeQuoteRequestIntoOrderOnSubmission'?: boolean | null;
    'FilterCatalogsByLocation'?: boolean | null;
    'PhoneNoRequiredOnRegistrationForm'?: boolean | null;
    'ShowDescriptionOnCheckout'?: boolean | null;
    'MakeRequestNotePrintableByDefault'?: boolean | null;
    'IsUniversity'?: boolean | null;
    'StudentIdRequiredOnRegistrationForm'?: boolean | null;
    'AutoplaySpeed'?: number | null;
    'AutoplayImagesOnLandingPage'?: boolean | null;
    'AutoplayImagesOnProductBrowser'?: boolean | null;
    'AutoplayImagesOnProductDetails'?: boolean | null;
    'ImagesTransitionEffect'?: string | null;
    'ImagesTransitionSpeed'?: string | null;
    'HomepageShowSiteHeader'?: boolean | null;
    'HomepageShowHeroSection'?: boolean | null;
    'HomepageHeroSectionHeading1'?: WebApiModulesIntegrationsStorefrontStorefrontTranslatedText;
    'HomepageHeroSectionHeading2'?: WebApiModulesIntegrationsStorefrontStorefrontTranslatedText;
    'HomepageHeroSectionHeading3'?: WebApiModulesIntegrationsStorefrontStorefrontTranslatedText;
    'HomepageCatalogItemWidth'?: string | null;
    'HomepageCatalogItemHeight'?: string | null;
    'HomepageShowFooter'?: boolean | null;
    'HomepageFooterText'?: WebApiModulesIntegrationsStorefrontStorefrontTranslatedText;
    'LandingPageShowCategoryBrowser'?: boolean | null;
    'LandingPageExpandInventoryTypesCategoriesAndSubCategoriesByDefault'?: boolean | null;
    'LandingPageCategoryBrowserItemWidth'?: string | null;
    'ShowReservationHourFields'?: boolean | null;
    'ToDateAdjustmentDays'?: number | null;
    'EnableHoursOfOperation'?: boolean | null;
    'OpenTime'?: string | null;
    'CloseTime'?: string | null;
    'EnableOpenDays'?: boolean | null;
    'OpenSunday'?: boolean | null;
    'OpenMonday'?: boolean | null;
    'OpenTuesday'?: boolean | null;
    'OpenWednesday'?: boolean | null;
    'OpenThursday'?: boolean | null;
    'OpenFriday'?: boolean | null;
    'OpenSaturday'?: boolean | null;
    'HideAvailabilityForAccessoryItems'?: boolean | null;
    'ShowOwnedQty'?: boolean | null;
    'ShowAvailabilityCalendar'?: boolean | null;
    'InitialAvailabilityCalendarView'?: string | null;
}

export const WebApiModulesIntegrationsStorefrontStorefrontSettingsPropertyDataTypes = {
    Boolean: 'Boolean',
    Text: 'Text',
    TranslatedText: 'TranslatedText',
    DropDown: 'DropDown',
    Number: 'Number',
    TimePicker24: 'TimePicker24'
} as const;

export type WebApiModulesIntegrationsStorefrontStorefrontSettingsPropertyDataTypes = typeof WebApiModulesIntegrationsStorefrontStorefrontSettingsPropertyDataTypes[keyof typeof WebApiModulesIntegrationsStorefrontStorefrontSettingsPropertyDataTypes];


export interface WebApiModulesIntegrationsStorefrontStorefrontSettingsPropertySchema {
    'Group'?: string | null;
    'Caption'?: string | null;
    'PropertyName'?: string | null;
    'DataType'?: WebApiModulesIntegrationsStorefrontStorefrontSettingsPropertyDataTypes;
    'Description'?: string | null;
    'ValidValues'?: Array<WebApiModulesIntegrationsStorefrontStorefrontSettingsPropertySchemaValidValue> | null;
}


export interface WebApiModulesIntegrationsStorefrontStorefrontSettingsPropertySchemaValidValue {
    'caption'?: string | null;
    'value'?: string | null;
}
export interface WebApiModulesIntegrationsStorefrontStorefrontTranslatedText {
    'en'?: string | null;
    'es'?: string | null;
    'fr'?: string | null;
}
export interface WebApiModulesIntegrationsStorefrontSubmitQuoteRequestResponse {
    'Success'?: boolean;
    'FailureMessage'?: string | null;
    'ProgressMeterSessionId'?: string | null;
}
export interface WebApiModulesIntegrationsStorefrontWebCatalog {
    'Id'?: string | null;
    'Name'?: string | null;
    'UrlName'?: string | null;
    'DealId'?: string | null;
    'DepartmentId'?: string | null;
    'LocationId'?: string | null;
    'WarehouseId'?: string | null;
    'AllowAddingUnavailableItems'?: boolean | null;
    'HasRental'?: boolean | null;
    'HasSales'?: boolean | null;
    'MinEquipmentRequestHours'?: number;
    'MaxEquipmentRequestHours'?: number;
    'GridFields'?: Array<WebApiModulesIntegrationsStorefrontWebCatalogResponseField> | null;
    'ListFields'?: Array<WebApiModulesIntegrationsStorefrontWebCatalogResponseField> | null;
    'DetailFields'?: Array<WebApiModulesIntegrationsStorefrontWebCatalogResponseField> | null;
    'ShoppingCartFields'?: Array<WebApiModulesIntegrationsStorefrontWebCatalogResponseField> | null;
    'Images'?: string | null;
    'LandingPageHtml'?: string | null;
    'Departments'?: Array<WebApiModulesIntegrationsStorefrontProductDepartment> | null;
    'WarehousesQtys'?: Array<WebApiModulesIntegrationsStorefrontWebCatalogWarehouseQtyDto> | null;
}
export interface WebApiModulesIntegrationsStorefrontWebCatalogResponseField {
    'Value'?: string | null;
    'Text'?: string | null;
    'Selected'?: boolean;
}
export interface WebApiModulesIntegrationsStorefrontWebCatalogWarehouseQtyDto {
    'WarehouseId'?: string | null;
    'TotalItems'?: number;
}

/**
 * StorefrontApi - axios parameter creator
 */
export const StorefrontApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Login with Azure/Entra ID (for Contacts)
         * @param {WebApiModulesAccountServicesJwtAzureADRequest} [webApiModulesAccountServicesJwtAzureADRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storefrontV1AzureLoginAsync: async (webApiModulesAccountServicesJwtAzureADRequest?: WebApiModulesAccountServicesJwtAzureADRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/storefront/login/azure`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(webApiModulesAccountServicesJwtAzureADRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get availability calendar data.
         * @param {string} inventoryId 
         * @param {string} warehouseId 
         * @param {string} fromDate 
         * @param {string} toDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storefrontV1GetAvailabilityCalendarAsync: async (inventoryId: string, warehouseId: string, fromDate: string, toDate: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'inventoryId' is not null or undefined
            assertParamExists('storefrontV1GetAvailabilityCalendarAsync', 'inventoryId', inventoryId)
            // verify required parameter 'warehouseId' is not null or undefined
            assertParamExists('storefrontV1GetAvailabilityCalendarAsync', 'warehouseId', warehouseId)
            // verify required parameter 'fromDate' is not null or undefined
            assertParamExists('storefrontV1GetAvailabilityCalendarAsync', 'fromDate', fromDate)
            // verify required parameter 'toDate' is not null or undefined
            assertParamExists('storefrontV1GetAvailabilityCalendarAsync', 'toDate', toDate)
            const localVarPath = `/api/v1/storefront/availability-calendar`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (inventoryId !== undefined) {
                localVarQueryParameter['InventoryId'] = inventoryId;
            }

            if (warehouseId !== undefined) {
                localVarQueryParameter['WarehouseId'] = warehouseId;
            }

            if (fromDate !== undefined) {
                localVarQueryParameter['FromDate'] = (fromDate as any instanceof Date) ?
                    (fromDate as any).toISOString() :
                    fromDate;
            }

            if (toDate !== undefined) {
                localVarQueryParameter['ToDate'] = (toDate as any instanceof Date) ?
                    (toDate as any).toISOString() :
                    toDate;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get catalog by id.
         * @param {string} catalogid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storefrontV1GetCatalogByIdAsync: async (catalogid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'catalogid' is not null or undefined
            assertParamExists('storefrontV1GetCatalogByIdAsync', 'catalogid', catalogid)
            const localVarPath = `/api/v1/storefront/catalog/{catalogid}`
                .replace(`{${"catalogid"}}`, encodeURIComponent(String(catalogid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get catalogs.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storefrontV1GetCatalogsAsync: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/storefront/catalog`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get categorytree for a catalog.
         * @param {string} catalogid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storefrontV1GetCategoryTreeAsync: async (catalogid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'catalogid' is not null or undefined
            assertParamExists('storefrontV1GetCategoryTreeAsync', 'catalogid', catalogid)
            const localVarPath = `/api/v1/storefront/catalog/{catalogid}/categorytree`
                .replace(`{${"catalogid"}}`, encodeURIComponent(String(catalogid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Lookup a list of valid deals for submitting quote requests
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storefrontV1GetDealAsync: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/storefront/lookupdeal`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get resolved RentalWorks holidays in a date range.
         * @param {string} [fromDate]
         * @param {string} [toDate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storefrontV1GetHolidaysAsync: async (fromDate?: string, toDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/storefront/holidays`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = (fromDate as any instanceof Date) ?
                    (fromDate as any).toISOString() :
                    fromDate;
            }

            if (toDate !== undefined) {
                localVarQueryParameter['toDate'] = (toDate as any instanceof Date) ?
                    (toDate as any).toISOString() :
                    toDate;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Lookup locations for a warehouse
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storefrontV1GetLocationsAsync: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/storefront/lookuplocation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns a list of Deals that the Contact is a member of.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storefrontV1GetMyDealsAsync: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/storefront/deals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get orders for a contact\'s deal (in the api token).
         * @param {number} [pageno] 
         * @param {number} [pagesize] 
         * @param {string} [sort] 
         * @param {Array<FwStandardModelsFwQueryFilter>} [filter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storefrontV1GetOrdersAsync: async (pageno?: number, pagesize?: number, sort?: string, filter?: Array<FwStandardModelsFwQueryFilter>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/storefront/orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageno !== undefined) {
                localVarQueryParameter['pageno'] = pageno;
            }

            if (pagesize !== undefined) {
                localVarQueryParameter['pagesize'] = pagesize;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (filter) {
                localVarQueryParameter['filter'] = filter;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get product details of a single product, availability will be defaulted to today + 6 days and use the location/warehouse from the product\'s catalog.
         * @param {string} productid 
         * @param {string} warehouseid 
         * @param {string} locationid 
         * @param {string} fromdate 
         * @param {string} todate 
         * @param {number} [pageno] 
         * @param {number} [pagesize] 
         * @param {string} [sort] 
         * @param {Array<FwStandardModelsFwQueryFilter>} [filter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storefrontV1GetProductAsync: async (productid: string, warehouseid: string, locationid: string, fromdate: string, todate: string, pageno?: number, pagesize?: number, sort?: string, filter?: Array<FwStandardModelsFwQueryFilter>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productid' is not null or undefined
            assertParamExists('storefrontV1GetProductAsync', 'productid', productid)
            // verify required parameter 'warehouseid' is not null or undefined
            assertParamExists('storefrontV1GetProductAsync', 'warehouseid', warehouseid)
            // verify required parameter 'locationid' is not null or undefined
            assertParamExists('storefrontV1GetProductAsync', 'locationid', locationid)
            // verify required parameter 'fromdate' is not null or undefined
            assertParamExists('storefrontV1GetProductAsync', 'fromdate', fromdate)
            // verify required parameter 'todate' is not null or undefined
            assertParamExists('storefrontV1GetProductAsync', 'todate', todate)
            const localVarPath = `/api/v1/storefront/product/{productid}/warehouseid/{warehouseid}/locationid/{locationid}/fromdate/{fromdate}/todate/{todate}`
                .replace(`{${"productid"}}`, encodeURIComponent(String(productid)))
                .replace(`{${"warehouseid"}}`, encodeURIComponent(String(warehouseid)))
                .replace(`{${"locationid"}}`, encodeURIComponent(String(locationid)))
                .replace(`{${"fromdate"}}`, encodeURIComponent(String(fromdate)))
                .replace(`{${"todate"}}`, encodeURIComponent(String(todate)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageno !== undefined) {
                localVarQueryParameter['pageno'] = pageno;
            }

            if (pagesize !== undefined) {
                localVarQueryParameter['pagesize'] = pagesize;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (filter) {
                localVarQueryParameter['filter'] = filter;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} inventoryid 
         * @param {string} warehouseid 
         * @param {string} fromdate 
         * @param {string} todate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storefrontV1GetProductAvailabilityAsync: async (inventoryid: string, warehouseid: string, fromdate: string, todate: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'inventoryid' is not null or undefined
            assertParamExists('storefrontV1GetProductAvailabilityAsync', 'inventoryid', inventoryid)
            // verify required parameter 'warehouseid' is not null or undefined
            assertParamExists('storefrontV1GetProductAvailabilityAsync', 'warehouseid', warehouseid)
            // verify required parameter 'fromdate' is not null or undefined
            assertParamExists('storefrontV1GetProductAvailabilityAsync', 'fromdate', fromdate)
            // verify required parameter 'todate' is not null or undefined
            assertParamExists('storefrontV1GetProductAvailabilityAsync', 'todate', todate)
            const localVarPath = `/api/v1/storefront/productavailability/inventoryid/{inventoryid}/warehouseid/{warehouseid}/fromdate/{fromdate}/todate/{todate}`
                .replace(`{${"inventoryid"}}`, encodeURIComponent(String(inventoryid)))
                .replace(`{${"warehouseid"}}`, encodeURIComponent(String(warehouseid)))
                .replace(`{${"fromdate"}}`, encodeURIComponent(String(fromdate)))
                .replace(`{${"todate"}}`, encodeURIComponent(String(todate)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get extended product details with availability and rates
         * @param {string} productid 
         * @param {string} locationid 
         * @param {string} warehouseid 
         * @param {string} fromdate 
         * @param {string} todate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storefrontV1GetProductDetailsAsync: async (productid: string, locationid: string, warehouseid: string, fromdate: string, todate: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productid' is not null or undefined
            assertParamExists('storefrontV1GetProductDetailsAsync', 'productid', productid)
            // verify required parameter 'locationid' is not null or undefined
            assertParamExists('storefrontV1GetProductDetailsAsync', 'locationid', locationid)
            // verify required parameter 'warehouseid' is not null or undefined
            assertParamExists('storefrontV1GetProductDetailsAsync', 'warehouseid', warehouseid)
            // verify required parameter 'fromdate' is not null or undefined
            assertParamExists('storefrontV1GetProductDetailsAsync', 'fromdate', fromdate)
            // verify required parameter 'todate' is not null or undefined
            assertParamExists('storefrontV1GetProductDetailsAsync', 'todate', todate)
            const localVarPath = `/api/v1/storefront/productdetails/productid/{productid}/locationid/{locationid}/warehouseid/{warehouseid}/fromdate/{fromdate}/todate/{todate}`
                .replace(`{${"productid"}}`, encodeURIComponent(String(productid)))
                .replace(`{${"locationid"}}`, encodeURIComponent(String(locationid)))
                .replace(`{${"warehouseid"}}`, encodeURIComponent(String(warehouseid)))
                .replace(`{${"fromdate"}}`, encodeURIComponent(String(fromdate)))
                .replace(`{${"todate"}}`, encodeURIComponent(String(todate)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the current status from a progress meter session.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storefrontV1GetProgressMeterAsync: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('storefrontV1GetProgressMeterAsync', 'id', id)
            const localVarPath = `/api/v1/storefront/progressmeter/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the authenticated Storefront session.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storefrontV1GetSessionAsync: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/storefront/session`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns storefront settings.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storefrontV1GetStorefrontSettingsAsync: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/storefront/settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns storefront settings.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storefrontV1GetStorefrontSettingsSchemaAsync: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/storefront/settings/schema`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the storefront api version.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storefrontV1GetVersionAsync: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/storefront/version`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Lookup warehouses
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storefrontV1GetWarehousesAsync: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/storefront/lookupwarehouse`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get products in a catalog.
         * @param {string} catalogid 
         * @param {string} warehouseid 
         * @param {string} locationid 
         * @param {number} [pageno] 
         * @param {number} [pagesize] 
         * @param {string} [sort] 
         * @param {Array<FwStandardModelsFwQueryFilter>} [filter] 
         * @param {string} [inventorydepartmentid] 
         * @param {string} [categoryid] 
         * @param {string} [subcategoryid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storefrontV1GetWebCatalogProductsAsync: async (catalogid: string, warehouseid: string, locationid: string, pageno?: number, pagesize?: number, sort?: string, filter?: Array<FwStandardModelsFwQueryFilter>, inventorydepartmentid?: string, categoryid?: string, subcategoryid?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'catalogid' is not null or undefined
            assertParamExists('storefrontV1GetWebCatalogProductsAsync', 'catalogid', catalogid)
            // verify required parameter 'warehouseid' is not null or undefined
            assertParamExists('storefrontV1GetWebCatalogProductsAsync', 'warehouseid', warehouseid)
            // verify required parameter 'locationid' is not null or undefined
            assertParamExists('storefrontV1GetWebCatalogProductsAsync', 'locationid', locationid)
            const localVarPath = `/api/v1/storefront/catalog/{catalogid}/products/warehouseid/{warehouseid}/locationid/{locationid}`
                .replace(`{${"catalogid"}}`, encodeURIComponent(String(catalogid)))
                .replace(`{${"warehouseid"}}`, encodeURIComponent(String(warehouseid)))
                .replace(`{${"locationid"}}`, encodeURIComponent(String(locationid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageno !== undefined) {
                localVarQueryParameter['pageno'] = pageno;
            }

            if (pagesize !== undefined) {
                localVarQueryParameter['pagesize'] = pagesize;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (filter) {
                localVarQueryParameter['filter'] = filter;
            }

            if (inventorydepartmentid !== undefined) {
                localVarQueryParameter['inventorydepartmentid'] = inventorydepartmentid;
            }

            if (categoryid !== undefined) {
                localVarQueryParameter['categoryid'] = categoryid;
            }

            if (subcategoryid !== undefined) {
                localVarQueryParameter['subcategoryid'] = subcategoryid;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get products by id with availability.  (for revalidating shopping cart)
         * @param {string} productids 
         * @param {string} locationid 
         * @param {string} warehouseid 
         * @param {string} fromdate 
         * @param {string} todate 
         * @param {number} [pageno] 
         * @param {number} [pagesize] 
         * @param {string} [sort] 
         * @param {Array<FwStandardModelsFwQueryFilter>} [filter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storefrontV1GetWebCatalogProductsByIdWithAvailabilityAsync: async (productids: string, locationid: string, warehouseid: string, fromdate: string, todate: string, pageno?: number, pagesize?: number, sort?: string, filter?: Array<FwStandardModelsFwQueryFilter>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productids' is not null or undefined
            assertParamExists('storefrontV1GetWebCatalogProductsByIdWithAvailabilityAsync', 'productids', productids)
            // verify required parameter 'locationid' is not null or undefined
            assertParamExists('storefrontV1GetWebCatalogProductsByIdWithAvailabilityAsync', 'locationid', locationid)
            // verify required parameter 'warehouseid' is not null or undefined
            assertParamExists('storefrontV1GetWebCatalogProductsByIdWithAvailabilityAsync', 'warehouseid', warehouseid)
            // verify required parameter 'fromdate' is not null or undefined
            assertParamExists('storefrontV1GetWebCatalogProductsByIdWithAvailabilityAsync', 'fromdate', fromdate)
            // verify required parameter 'todate' is not null or undefined
            assertParamExists('storefrontV1GetWebCatalogProductsByIdWithAvailabilityAsync', 'todate', todate)
            const localVarPath = `/api/v1/storefront/products/{productids}/locationid/{locationid}/warehouseid/{warehouseid}/fromdate/{fromdate}/todate/{todate}`
                .replace(`{${"productids"}}`, encodeURIComponent(String(productids)))
                .replace(`{${"locationid"}}`, encodeURIComponent(String(locationid)))
                .replace(`{${"warehouseid"}}`, encodeURIComponent(String(warehouseid)))
                .replace(`{${"fromdate"}}`, encodeURIComponent(String(fromdate)))
                .replace(`{${"todate"}}`, encodeURIComponent(String(todate)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageno !== undefined) {
                localVarQueryParameter['pageno'] = pageno;
            }

            if (pagesize !== undefined) {
                localVarQueryParameter['pagesize'] = pagesize;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (filter) {
                localVarQueryParameter['filter'] = filter;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get products by comma separated list of InventoryIds with availability.   (When a product is removed from a catalog the catalog\'s product id will change, so we can query this endpoint to update the product ids in a users shopping cart if we can find the same InventoryId on a different catalog listing.
         * @param {string} inventoryids 
         * @param {string} locationid 
         * @param {string} warehouseid 
         * @param {string} fromdate 
         * @param {string} todate 
         * @param {number} [pageno] 
         * @param {number} [pagesize] 
         * @param {string} [sort] 
         * @param {Array<FwStandardModelsFwQueryFilter>} [filter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storefrontV1GetWebCatalogProductsByInventoryIdsWithAvailabilityAsync: async (inventoryids: string, locationid: string, warehouseid: string, fromdate: string, todate: string, pageno?: number, pagesize?: number, sort?: string, filter?: Array<FwStandardModelsFwQueryFilter>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'inventoryids' is not null or undefined
            assertParamExists('storefrontV1GetWebCatalogProductsByInventoryIdsWithAvailabilityAsync', 'inventoryids', inventoryids)
            // verify required parameter 'locationid' is not null or undefined
            assertParamExists('storefrontV1GetWebCatalogProductsByInventoryIdsWithAvailabilityAsync', 'locationid', locationid)
            // verify required parameter 'warehouseid' is not null or undefined
            assertParamExists('storefrontV1GetWebCatalogProductsByInventoryIdsWithAvailabilityAsync', 'warehouseid', warehouseid)
            // verify required parameter 'fromdate' is not null or undefined
            assertParamExists('storefrontV1GetWebCatalogProductsByInventoryIdsWithAvailabilityAsync', 'fromdate', fromdate)
            // verify required parameter 'todate' is not null or undefined
            assertParamExists('storefrontV1GetWebCatalogProductsByInventoryIdsWithAvailabilityAsync', 'todate', todate)
            const localVarPath = `/api/v1/storefront/products/inventoryids/{inventoryids}/locationid/{locationid}/warehouseid/{warehouseid}/fromdate/{fromdate}/todate/{todate}`
                .replace(`{${"inventoryids"}}`, encodeURIComponent(String(inventoryids)))
                .replace(`{${"locationid"}}`, encodeURIComponent(String(locationid)))
                .replace(`{${"warehouseid"}}`, encodeURIComponent(String(warehouseid)))
                .replace(`{${"fromdate"}}`, encodeURIComponent(String(fromdate)))
                .replace(`{${"todate"}}`, encodeURIComponent(String(todate)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageno !== undefined) {
                localVarQueryParameter['pageno'] = pageno;
            }

            if (pagesize !== undefined) {
                localVarQueryParameter['pagesize'] = pagesize;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (filter) {
                localVarQueryParameter['filter'] = filter;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get products in a catalog with availability.
         * @param {string} catalogid 
         * @param {string} locationid 
         * @param {string} warehouseid 
         * @param {string} fromdate 
         * @param {string} todate 
         * @param {number} [pageno] 
         * @param {number} [pagesize] 
         * @param {string} [sort] 
         * @param {Array<FwStandardModelsFwQueryFilter>} [filter] 
         * @param {string} [inventorydepartmentid] 
         * @param {string} [categoryid] 
         * @param {string} [subcategoryid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storefrontV1GetWebCatalogProductsWithAvailabilityAsync: async (catalogid: string, locationid: string, warehouseid: string, fromdate: string, todate: string, pageno?: number, pagesize?: number, sort?: string, filter?: Array<FwStandardModelsFwQueryFilter>, inventorydepartmentid?: string, categoryid?: string, subcategoryid?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'catalogid' is not null or undefined
            assertParamExists('storefrontV1GetWebCatalogProductsWithAvailabilityAsync', 'catalogid', catalogid)
            // verify required parameter 'locationid' is not null or undefined
            assertParamExists('storefrontV1GetWebCatalogProductsWithAvailabilityAsync', 'locationid', locationid)
            // verify required parameter 'warehouseid' is not null or undefined
            assertParamExists('storefrontV1GetWebCatalogProductsWithAvailabilityAsync', 'warehouseid', warehouseid)
            // verify required parameter 'fromdate' is not null or undefined
            assertParamExists('storefrontV1GetWebCatalogProductsWithAvailabilityAsync', 'fromdate', fromdate)
            // verify required parameter 'todate' is not null or undefined
            assertParamExists('storefrontV1GetWebCatalogProductsWithAvailabilityAsync', 'todate', todate)
            const localVarPath = `/api/v1/storefront/catalog/{catalogid}/products/locationid/{locationid}/warehouseid/{warehouseid}/fromdate/{fromdate}/todate/{todate}`
                .replace(`{${"catalogid"}}`, encodeURIComponent(String(catalogid)))
                .replace(`{${"locationid"}}`, encodeURIComponent(String(locationid)))
                .replace(`{${"warehouseid"}}`, encodeURIComponent(String(warehouseid)))
                .replace(`{${"fromdate"}}`, encodeURIComponent(String(fromdate)))
                .replace(`{${"todate"}}`, encodeURIComponent(String(todate)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageno !== undefined) {
                localVarQueryParameter['pageno'] = pageno;
            }

            if (pagesize !== undefined) {
                localVarQueryParameter['pagesize'] = pagesize;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (filter) {
                localVarQueryParameter['filter'] = filter;
            }

            if (inventorydepartmentid !== undefined) {
                localVarQueryParameter['inventorydepartmentid'] = inventorydepartmentid;
            }

            if (categoryid !== undefined) {
                localVarQueryParameter['categoryid'] = categoryid;
            }

            if (subcategoryid !== undefined) {
                localVarQueryParameter['subcategoryid'] = subcategoryid;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Login (for Contacts)
         * @param {WebApiModulesIntegrationsStorefrontLoginRequest} [webApiModulesIntegrationsStorefrontLoginRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storefrontV1LoginAsync: async (webApiModulesIntegrationsStorefrontLoginRequest?: WebApiModulesIntegrationsStorefrontLoginRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/storefront/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(webApiModulesIntegrationsStorefrontLoginRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Logout (for Contacts)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storefrontV1LogoutAsync: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/storefront/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns a list of items in the Storefront shopping cart format based on items in an order
         * @param {string} [orderId] 
         * @param {string} [webCatalogId] 
         * @param {string} [fromDate]
         * @param {string} [toDate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storefrontV1OrderToShoppingCartItemsAsync: async (orderId?: string, webCatalogId?: string, fromDate?: string, toDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/storefront/order-to-shopping-cart-items`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (orderId !== undefined) {
                localVarQueryParameter['OrderId'] = orderId;
            }

            if (webCatalogId !== undefined) {
                localVarQueryParameter['WebCatalogId'] = webCatalogId;
            }

            if (fromDate !== undefined) {
                localVarQueryParameter['FromDate'] = fromDate;
            }

            if (toDate !== undefined) {
                localVarQueryParameter['ToDate'] = toDate;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Register a new account (Contact)
         * @param {WebApiModulesIntegrationsStorefrontContactRegistrationRequest} [webApiModulesIntegrationsStorefrontContactRegistrationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storefrontV1RegisterAsync: async (webApiModulesIntegrationsStorefrontContactRegistrationRequest?: WebApiModulesIntegrationsStorefrontContactRegistrationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/storefront/register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(webApiModulesIntegrationsStorefrontContactRegistrationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Renders an order report and returns a URL to the PDF.
         * @param {string} [orderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storefrontV1RenderOrderPdfAsync: async (orderId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/storefront/render-order-report`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (orderId !== undefined) {
                localVarQueryParameter['OrderId'] = orderId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Renders a quote report and returns a URL to the PDF.
         * @param {string} [quoteId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storefrontV1RenderQuotePdfAsync: async (quoteId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/storefront/render-quote-report`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (quoteId !== undefined) {
                localVarQueryParameter['QuoteId'] = quoteId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Send email to Reset Password (for Contacts)
         * @param {WebApiModulesIntegrationsStorefrontResetPasswordFromEmailRequest} [webApiModulesIntegrationsStorefrontResetPasswordFromEmailRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storefrontV1ResetPasswordFromEmailAsync: async (webApiModulesIntegrationsStorefrontResetPasswordFromEmailRequest?: WebApiModulesIntegrationsStorefrontResetPasswordFromEmailRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/storefront/resetpasswordfromemail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(webApiModulesIntegrationsStorefrontResetPasswordFromEmailRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Send email to Change Password (for Contacts)
         * @param {WebApiModulesIntegrationsStorefrontSendResetPasswordEmailRequest} [webApiModulesIntegrationsStorefrontSendResetPasswordEmailRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storefrontV1SendChangePasswordEmailAsync: async (webApiModulesIntegrationsStorefrontSendResetPasswordEmailRequest?: WebApiModulesIntegrationsStorefrontSendResetPasswordEmailRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/storefront/sendchangepasswordemail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(webApiModulesIntegrationsStorefrontSendResetPasswordEmailRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Send an inquiry email about an item.
         * @param {WebApiModulesIntegrationsStorefrontSendInquiryEmailRequest} [webApiModulesIntegrationsStorefrontSendInquiryEmailRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storefrontV1SendInquiryEmailRequestAsync: async (webApiModulesIntegrationsStorefrontSendInquiryEmailRequest?: WebApiModulesIntegrationsStorefrontSendInquiryEmailRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/storefront/sendinquiryemail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(webApiModulesIntegrationsStorefrontSendInquiryEmailRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Send email to Reset Password (for Contacts)
         * @param {WebApiModulesIntegrationsStorefrontSendResetPasswordEmailRequest} [webApiModulesIntegrationsStorefrontSendResetPasswordEmailRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storefrontV1SendResetPasswordEmailAsync: async (webApiModulesIntegrationsStorefrontSendResetPasswordEmailRequest?: WebApiModulesIntegrationsStorefrontSendResetPasswordEmailRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/storefront/sendresetpasswordemail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(webApiModulesIntegrationsStorefrontSendResetPasswordEmailRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Submit a Quote Request
         * @param {WebApiModulesIntegrationsStorefrontQuoteRequest} [webApiModulesIntegrationsStorefrontQuoteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storefrontV1SubmitQuoteRequestAsync: async (webApiModulesIntegrationsStorefrontQuoteRequest?: WebApiModulesIntegrationsStorefrontQuoteRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/storefront/submitquoterequest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(webApiModulesIntegrationsStorefrontQuoteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StorefrontApi - functional programming interface
 */
export const StorefrontApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StorefrontApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Login with Azure/Entra ID (for Contacts)
         * @param {WebApiModulesAccountServicesJwtAzureADRequest} [webApiModulesAccountServicesJwtAzureADRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storefrontV1AzureLoginAsync(webApiModulesAccountServicesJwtAzureADRequest?: WebApiModulesAccountServicesJwtAzureADRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebApiModulesIntegrationsPortalAuthSvcLoginResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storefrontV1AzureLoginAsync(webApiModulesAccountServicesJwtAzureADRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorefrontApi.storefrontV1AzureLoginAsync']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get availability calendar data.
         * @param {string} inventoryId 
         * @param {string} warehouseId 
         * @param {string} fromDate 
         * @param {string} toDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storefrontV1GetAvailabilityCalendarAsync(inventoryId: string, warehouseId: string, fromDate: string, toDate: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InventoryAvailabilityCalendarResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storefrontV1GetAvailabilityCalendarAsync(inventoryId, warehouseId, fromDate, toDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorefrontApi.storefrontV1GetAvailabilityCalendarAsync']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get catalog by id.
         * @param {string} catalogid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storefrontV1GetCatalogByIdAsync(catalogid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WebApiModulesIntegrationsStorefrontWebCatalog>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storefrontV1GetCatalogByIdAsync(catalogid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorefrontApi.storefrontV1GetCatalogByIdAsync']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get catalogs.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storefrontV1GetCatalogsAsync(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WebApiModulesIntegrationsStorefrontWebCatalog>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storefrontV1GetCatalogsAsync(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorefrontApi.storefrontV1GetCatalogsAsync']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get categorytree for a catalog.
         * @param {string} catalogid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storefrontV1GetCategoryTreeAsync(catalogid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebApiModulesIntegrationsStorefrontWebCatalog>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storefrontV1GetCategoryTreeAsync(catalogid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorefrontApi.storefrontV1GetCategoryTreeAsync']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Lookup a list of valid deals for submitting quote requests
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storefrontV1GetDealAsync(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WebApiModulesIntegrationsStorefrontDealModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storefrontV1GetDealAsync(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorefrontApi.storefrontV1GetDealAsync']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get resolved RentalWorks holidays in a date range.
         * @param {string} [fromDate]
         * @param {string} [toDate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storefrontV1GetHolidaysAsync(fromDate?: string, toDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StorefrontHolidayDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storefrontV1GetHolidaysAsync(fromDate, toDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorefrontApi.storefrontV1GetHolidaysAsync']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Lookup locations for a warehouse
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storefrontV1GetLocationsAsync(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WebApiModulesIntegrationsStorefrontLocationModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storefrontV1GetLocationsAsync(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorefrontApi.storefrontV1GetLocationsAsync']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Returns a list of Deals that the Contact is a member of.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storefrontV1GetMyDealsAsync(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WebApiModulesIntegrationsPortalServicesPortalSvcDtoDealResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storefrontV1GetMyDealsAsync(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorefrontApi.storefrontV1GetMyDealsAsync']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get orders for a contact\'s deal (in the api token).
         * @param {number} [pageno] 
         * @param {number} [pagesize] 
         * @param {string} [sort] 
         * @param {Array<FwStandardModelsFwQueryFilter>} [filter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storefrontV1GetOrdersAsync(pageno?: number, pagesize?: number, sort?: string, filter?: Array<FwStandardModelsFwQueryFilter>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FwStandardModelsFwQueryResponseStorefrontOrderDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storefrontV1GetOrdersAsync(pageno, pagesize, sort, filter, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorefrontApi.storefrontV1GetOrdersAsync']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get product details of a single product, availability will be defaulted to today + 6 days and use the location/warehouse from the product\'s catalog.
         * @param {string} productid 
         * @param {string} warehouseid 
         * @param {string} locationid 
         * @param {string} fromdate 
         * @param {string} todate 
         * @param {number} [pageno] 
         * @param {number} [pagesize] 
         * @param {string} [sort] 
         * @param {Array<FwStandardModelsFwQueryFilter>} [filter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storefrontV1GetProductAsync(productid: string, warehouseid: string, locationid: string, fromdate: string, todate: string, pageno?: number, pagesize?: number, sort?: string, filter?: Array<FwStandardModelsFwQueryFilter>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebApiModulesIntegrationsStorefrontStorefrontProductL>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storefrontV1GetProductAsync(productid, warehouseid, locationid, fromdate, todate, pageno, pagesize, sort, filter, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorefrontApi.storefrontV1GetProductAsync']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} inventoryid 
         * @param {string} warehouseid 
         * @param {string} fromdate 
         * @param {string} todate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storefrontV1GetProductAvailabilityAsync(inventoryid: string, warehouseid: string, fromdate: string, todate: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebApiModulesIntegrationsStorefrontProductAvailability>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storefrontV1GetProductAvailabilityAsync(inventoryid, warehouseid, fromdate, todate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorefrontApi.storefrontV1GetProductAvailabilityAsync']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get extended product details with availability and rates
         * @param {string} productid 
         * @param {string} locationid 
         * @param {string} warehouseid 
         * @param {string} fromdate 
         * @param {string} todate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storefrontV1GetProductDetailsAsync(productid: string, locationid: string, warehouseid: string, fromdate: string, todate: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebApiModulesIntegrationsStorefrontGetProductWarehouseDetailsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storefrontV1GetProductDetailsAsync(productid, locationid, warehouseid, fromdate, todate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorefrontApi.storefrontV1GetProductDetailsAsync']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Returns the current status from a progress meter session.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storefrontV1GetProgressMeterAsync(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebApiModulesIntegrationsStorefrontStorefrontProgress>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storefrontV1GetProgressMeterAsync(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorefrontApi.storefrontV1GetProgressMeterAsync']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Returns the authenticated Storefront session.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storefrontV1GetSessionAsync(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebApiModulesIntegrationsPortalAuthSvcLoginResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storefrontV1GetSessionAsync(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorefrontApi.storefrontV1GetSessionAsync']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Returns storefront settings.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storefrontV1GetStorefrontSettingsAsync(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebApiModulesIntegrationsStorefrontStorefrontSettings>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storefrontV1GetStorefrontSettingsAsync(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorefrontApi.storefrontV1GetStorefrontSettingsAsync']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Returns storefront settings.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storefrontV1GetStorefrontSettingsSchemaAsync(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WebApiModulesIntegrationsStorefrontStorefrontSettingsPropertySchema>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storefrontV1GetStorefrontSettingsSchemaAsync(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorefrontApi.storefrontV1GetStorefrontSettingsSchemaAsync']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Returns the storefront api version.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storefrontV1GetVersionAsync(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storefrontV1GetVersionAsync(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorefrontApi.storefrontV1GetVersionAsync']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Lookup warehouses
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storefrontV1GetWarehousesAsync(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WebApiModulesIntegrationsStorefrontLocationModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storefrontV1GetWarehousesAsync(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorefrontApi.storefrontV1GetWarehousesAsync']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get products in a catalog.
         * @param {string} catalogid 
         * @param {string} warehouseid 
         * @param {string} locationid 
         * @param {number} [pageno] 
         * @param {number} [pagesize] 
         * @param {string} [sort] 
         * @param {Array<FwStandardModelsFwQueryFilter>} [filter] 
         * @param {string} [inventorydepartmentid] 
         * @param {string} [categoryid] 
         * @param {string} [subcategoryid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storefrontV1GetWebCatalogProductsAsync(catalogid: string, warehouseid: string, locationid: string, pageno?: number, pagesize?: number, sort?: string, filter?: Array<FwStandardModelsFwQueryFilter>, inventorydepartmentid?: string, categoryid?: string, subcategoryid?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FwStandardModelsFwQueryResponseWebApiModulesIntegrationsStorefrontStorefrontProductLoader>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storefrontV1GetWebCatalogProductsAsync(catalogid, warehouseid, locationid, pageno, pagesize, sort, filter, inventorydepartmentid, categoryid, subcategoryid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorefrontApi.storefrontV1GetWebCatalogProductsAsync']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get products by id with availability.  (for revalidating shopping cart)
         * @param {string} productids 
         * @param {string} locationid 
         * @param {string} warehouseid 
         * @param {string} fromdate 
         * @param {string} todate 
         * @param {number} [pageno] 
         * @param {number} [pagesize] 
         * @param {string} [sort] 
         * @param {Array<FwStandardModelsFwQueryFilter>} [filter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storefrontV1GetWebCatalogProductsByIdWithAvailabilityAsync(productids: string, locationid: string, warehouseid: string, fromdate: string, todate: string, pageno?: number, pagesize?: number, sort?: string, filter?: Array<FwStandardModelsFwQueryFilter>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FwStandardModelsFwQueryResponseWebApiModulesIntegrationsStorefrontStorefrontProductLoader>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storefrontV1GetWebCatalogProductsByIdWithAvailabilityAsync(productids, locationid, warehouseid, fromdate, todate, pageno, pagesize, sort, filter, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorefrontApi.storefrontV1GetWebCatalogProductsByIdWithAvailabilityAsync']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get products by comma separated list of InventoryIds with availability.   (When a product is removed from a catalog the catalog\'s product id will change, so we can query this endpoint to update the product ids in a users shopping cart if we can find the same InventoryId on a different catalog listing.
         * @param {string} inventoryids 
         * @param {string} locationid 
         * @param {string} warehouseid 
         * @param {string} fromdate 
         * @param {string} todate 
         * @param {number} [pageno] 
         * @param {number} [pagesize] 
         * @param {string} [sort] 
         * @param {Array<FwStandardModelsFwQueryFilter>} [filter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storefrontV1GetWebCatalogProductsByInventoryIdsWithAvailabilityAsync(inventoryids: string, locationid: string, warehouseid: string, fromdate: string, todate: string, pageno?: number, pagesize?: number, sort?: string, filter?: Array<FwStandardModelsFwQueryFilter>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FwStandardModelsFwQueryResponseWebApiModulesIntegrationsStorefrontStorefrontProductLoader>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storefrontV1GetWebCatalogProductsByInventoryIdsWithAvailabilityAsync(inventoryids, locationid, warehouseid, fromdate, todate, pageno, pagesize, sort, filter, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorefrontApi.storefrontV1GetWebCatalogProductsByInventoryIdsWithAvailabilityAsync']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get products in a catalog with availability.
         * @param {string} catalogid 
         * @param {string} locationid 
         * @param {string} warehouseid 
         * @param {string} fromdate 
         * @param {string} todate 
         * @param {number} [pageno] 
         * @param {number} [pagesize] 
         * @param {string} [sort] 
         * @param {Array<FwStandardModelsFwQueryFilter>} [filter] 
         * @param {string} [inventorydepartmentid] 
         * @param {string} [categoryid] 
         * @param {string} [subcategoryid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storefrontV1GetWebCatalogProductsWithAvailabilityAsync(catalogid: string, locationid: string, warehouseid: string, fromdate: string, todate: string, pageno?: number, pagesize?: number, sort?: string, filter?: Array<FwStandardModelsFwQueryFilter>, inventorydepartmentid?: string, categoryid?: string, subcategoryid?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FwStandardModelsFwQueryResponseWebApiModulesIntegrationsStorefrontStorefrontProductLoader>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storefrontV1GetWebCatalogProductsWithAvailabilityAsync(catalogid, locationid, warehouseid, fromdate, todate, pageno, pagesize, sort, filter, inventorydepartmentid, categoryid, subcategoryid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorefrontApi.storefrontV1GetWebCatalogProductsWithAvailabilityAsync']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Login (for Contacts)
         * @param {WebApiModulesIntegrationsStorefrontLoginRequest} [webApiModulesIntegrationsStorefrontLoginRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storefrontV1LoginAsync(webApiModulesIntegrationsStorefrontLoginRequest?: WebApiModulesIntegrationsStorefrontLoginRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebApiModulesIntegrationsPortalAuthSvcLoginResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storefrontV1LoginAsync(webApiModulesIntegrationsStorefrontLoginRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorefrontApi.storefrontV1LoginAsync']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Logout (for Contacts)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storefrontV1LogoutAsync(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storefrontV1LogoutAsync(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorefrontApi.storefrontV1LogoutAsync']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Returns a list of items in the Storefront shopping cart format based on items in an order
         * @param {string} [orderId] 
         * @param {string} [webCatalogId] 
         * @param {string} [fromDate]
         * @param {string} [toDate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storefrontV1OrderToShoppingCartItemsAsync(orderId?: string, webCatalogId?: string, fromDate?: string, toDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ShoppingCartItemDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storefrontV1OrderToShoppingCartItemsAsync(orderId, webCatalogId, fromDate, toDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorefrontApi.storefrontV1OrderToShoppingCartItemsAsync']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Register a new account (Contact)
         * @param {WebApiModulesIntegrationsStorefrontContactRegistrationRequest} [webApiModulesIntegrationsStorefrontContactRegistrationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storefrontV1RegisterAsync(webApiModulesIntegrationsStorefrontContactRegistrationRequest?: WebApiModulesIntegrationsStorefrontContactRegistrationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebApiModulesIntegrationsStorefrontContactRegistrationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storefrontV1RegisterAsync(webApiModulesIntegrationsStorefrontContactRegistrationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorefrontApi.storefrontV1RegisterAsync']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Renders an order report and returns a URL to the PDF.
         * @param {string} [orderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storefrontV1RenderOrderPdfAsync(orderId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storefrontV1RenderOrderPdfAsync(orderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorefrontApi.storefrontV1RenderOrderPdfAsync']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Renders a quote report and returns a URL to the PDF.
         * @param {string} [quoteId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storefrontV1RenderQuotePdfAsync(quoteId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storefrontV1RenderQuotePdfAsync(quoteId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorefrontApi.storefrontV1RenderQuotePdfAsync']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Send email to Reset Password (for Contacts)
         * @param {WebApiModulesIntegrationsStorefrontResetPasswordFromEmailRequest} [webApiModulesIntegrationsStorefrontResetPasswordFromEmailRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storefrontV1ResetPasswordFromEmailAsync(webApiModulesIntegrationsStorefrontResetPasswordFromEmailRequest?: WebApiModulesIntegrationsStorefrontResetPasswordFromEmailRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebApiModulesIntegrationsPortalAuthSvcLoginResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storefrontV1ResetPasswordFromEmailAsync(webApiModulesIntegrationsStorefrontResetPasswordFromEmailRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorefrontApi.storefrontV1ResetPasswordFromEmailAsync']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Send email to Change Password (for Contacts)
         * @param {WebApiModulesIntegrationsStorefrontSendResetPasswordEmailRequest} [webApiModulesIntegrationsStorefrontSendResetPasswordEmailRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storefrontV1SendChangePasswordEmailAsync(webApiModulesIntegrationsStorefrontSendResetPasswordEmailRequest?: WebApiModulesIntegrationsStorefrontSendResetPasswordEmailRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storefrontV1SendChangePasswordEmailAsync(webApiModulesIntegrationsStorefrontSendResetPasswordEmailRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorefrontApi.storefrontV1SendChangePasswordEmailAsync']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Send an inquiry email about an item.
         * @param {WebApiModulesIntegrationsStorefrontSendInquiryEmailRequest} [webApiModulesIntegrationsStorefrontSendInquiryEmailRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storefrontV1SendInquiryEmailRequestAsync(webApiModulesIntegrationsStorefrontSendInquiryEmailRequest?: WebApiModulesIntegrationsStorefrontSendInquiryEmailRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebApiModulesIntegrationsStorefrontSendInquiryEmailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storefrontV1SendInquiryEmailRequestAsync(webApiModulesIntegrationsStorefrontSendInquiryEmailRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorefrontApi.storefrontV1SendInquiryEmailRequestAsync']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Send email to Reset Password (for Contacts)
         * @param {WebApiModulesIntegrationsStorefrontSendResetPasswordEmailRequest} [webApiModulesIntegrationsStorefrontSendResetPasswordEmailRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storefrontV1SendResetPasswordEmailAsync(webApiModulesIntegrationsStorefrontSendResetPasswordEmailRequest?: WebApiModulesIntegrationsStorefrontSendResetPasswordEmailRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storefrontV1SendResetPasswordEmailAsync(webApiModulesIntegrationsStorefrontSendResetPasswordEmailRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorefrontApi.storefrontV1SendResetPasswordEmailAsync']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Submit a Quote Request
         * @param {WebApiModulesIntegrationsStorefrontQuoteRequest} [webApiModulesIntegrationsStorefrontQuoteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storefrontV1SubmitQuoteRequestAsync(webApiModulesIntegrationsStorefrontQuoteRequest?: WebApiModulesIntegrationsStorefrontQuoteRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebApiModulesIntegrationsStorefrontSubmitQuoteRequestResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storefrontV1SubmitQuoteRequestAsync(webApiModulesIntegrationsStorefrontQuoteRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorefrontApi.storefrontV1SubmitQuoteRequestAsync']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * StorefrontApi - factory interface
 */
export const StorefrontApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StorefrontApiFp(configuration)
    return {
        /**
         * 
         * @summary Login with Azure/Entra ID (for Contacts)
         * @param {WebApiModulesAccountServicesJwtAzureADRequest} [webApiModulesAccountServicesJwtAzureADRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storefrontV1AzureLoginAsync(webApiModulesAccountServicesJwtAzureADRequest?: WebApiModulesAccountServicesJwtAzureADRequest, options?: RawAxiosRequestConfig): AxiosPromise<WebApiModulesIntegrationsPortalAuthSvcLoginResponseDto> {
            return localVarFp.storefrontV1AzureLoginAsync(webApiModulesAccountServicesJwtAzureADRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get availability calendar data.
         * @param {string} inventoryId 
         * @param {string} warehouseId 
         * @param {string} fromDate 
         * @param {string} toDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storefrontV1GetAvailabilityCalendarAsync(inventoryId: string, warehouseId: string, fromDate: string, toDate: string, options?: RawAxiosRequestConfig): AxiosPromise<InventoryAvailabilityCalendarResponseDto> {
            return localVarFp.storefrontV1GetAvailabilityCalendarAsync(inventoryId, warehouseId, fromDate, toDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get catalog by id.
         * @param {string} catalogid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storefrontV1GetCatalogByIdAsync(catalogid: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<WebApiModulesIntegrationsStorefrontWebCatalog>> {
            return localVarFp.storefrontV1GetCatalogByIdAsync(catalogid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get catalogs.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storefrontV1GetCatalogsAsync(options?: RawAxiosRequestConfig): AxiosPromise<Array<WebApiModulesIntegrationsStorefrontWebCatalog>> {
            return localVarFp.storefrontV1GetCatalogsAsync(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get categorytree for a catalog.
         * @param {string} catalogid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storefrontV1GetCategoryTreeAsync(catalogid: string, options?: RawAxiosRequestConfig): AxiosPromise<WebApiModulesIntegrationsStorefrontWebCatalog> {
            return localVarFp.storefrontV1GetCategoryTreeAsync(catalogid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Lookup a list of valid deals for submitting quote requests
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storefrontV1GetDealAsync(options?: RawAxiosRequestConfig): AxiosPromise<Array<WebApiModulesIntegrationsStorefrontDealModel>> {
            return localVarFp.storefrontV1GetDealAsync(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get resolved RentalWorks holidays in a date range.
         * @param {string} [fromDate]
         * @param {string} [toDate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storefrontV1GetHolidaysAsync(fromDate?: string, toDate?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<StorefrontHolidayDto>> {
            return localVarFp.storefrontV1GetHolidaysAsync(fromDate, toDate, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Lookup locations for a warehouse
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storefrontV1GetLocationsAsync(options?: RawAxiosRequestConfig): AxiosPromise<Array<WebApiModulesIntegrationsStorefrontLocationModel>> {
            return localVarFp.storefrontV1GetLocationsAsync(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns a list of Deals that the Contact is a member of.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storefrontV1GetMyDealsAsync(options?: RawAxiosRequestConfig): AxiosPromise<Array<WebApiModulesIntegrationsPortalServicesPortalSvcDtoDealResponseDto>> {
            return localVarFp.storefrontV1GetMyDealsAsync(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get orders for a contact\'s deal (in the api token).
         * @param {number} [pageno] 
         * @param {number} [pagesize] 
         * @param {string} [sort] 
         * @param {Array<FwStandardModelsFwQueryFilter>} [filter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storefrontV1GetOrdersAsync(pageno?: number, pagesize?: number, sort?: string, filter?: Array<FwStandardModelsFwQueryFilter>, options?: RawAxiosRequestConfig): AxiosPromise<FwStandardModelsFwQueryResponseStorefrontOrderDto> {
            return localVarFp.storefrontV1GetOrdersAsync(pageno, pagesize, sort, filter, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get product details of a single product, availability will be defaulted to today + 6 days and use the location/warehouse from the product\'s catalog.
         * @param {string} productid 
         * @param {string} warehouseid 
         * @param {string} locationid 
         * @param {string} fromdate 
         * @param {string} todate 
         * @param {number} [pageno] 
         * @param {number} [pagesize] 
         * @param {string} [sort] 
         * @param {Array<FwStandardModelsFwQueryFilter>} [filter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storefrontV1GetProductAsync(productid: string, warehouseid: string, locationid: string, fromdate: string, todate: string, pageno?: number, pagesize?: number, sort?: string, filter?: Array<FwStandardModelsFwQueryFilter>, options?: RawAxiosRequestConfig): AxiosPromise<WebApiModulesIntegrationsStorefrontStorefrontProductL> {
            return localVarFp.storefrontV1GetProductAsync(productid, warehouseid, locationid, fromdate, todate, pageno, pagesize, sort, filter, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} inventoryid 
         * @param {string} warehouseid 
         * @param {string} fromdate 
         * @param {string} todate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storefrontV1GetProductAvailabilityAsync(inventoryid: string, warehouseid: string, fromdate: string, todate: string, options?: RawAxiosRequestConfig): AxiosPromise<WebApiModulesIntegrationsStorefrontProductAvailability> {
            return localVarFp.storefrontV1GetProductAvailabilityAsync(inventoryid, warehouseid, fromdate, todate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get extended product details with availability and rates
         * @param {string} productid 
         * @param {string} locationid 
         * @param {string} warehouseid 
         * @param {string} fromdate 
         * @param {string} todate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storefrontV1GetProductDetailsAsync(productid: string, locationid: string, warehouseid: string, fromdate: string, todate: string, options?: RawAxiosRequestConfig): AxiosPromise<WebApiModulesIntegrationsStorefrontGetProductWarehouseDetailsResponse> {
            return localVarFp.storefrontV1GetProductDetailsAsync(productid, locationid, warehouseid, fromdate, todate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the current status from a progress meter session.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storefrontV1GetProgressMeterAsync(id: string, options?: RawAxiosRequestConfig): AxiosPromise<WebApiModulesIntegrationsStorefrontStorefrontProgress> {
            return localVarFp.storefrontV1GetProgressMeterAsync(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the authenticated Storefront session.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storefrontV1GetSessionAsync(options?: RawAxiosRequestConfig): AxiosPromise<WebApiModulesIntegrationsPortalAuthSvcLoginResponseDto> {
            return localVarFp.storefrontV1GetSessionAsync(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns storefront settings.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storefrontV1GetStorefrontSettingsAsync(options?: RawAxiosRequestConfig): AxiosPromise<WebApiModulesIntegrationsStorefrontStorefrontSettings> {
            return localVarFp.storefrontV1GetStorefrontSettingsAsync(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns storefront settings.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storefrontV1GetStorefrontSettingsSchemaAsync(options?: RawAxiosRequestConfig): AxiosPromise<Array<WebApiModulesIntegrationsStorefrontStorefrontSettingsPropertySchema>> {
            return localVarFp.storefrontV1GetStorefrontSettingsSchemaAsync(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the storefront api version.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storefrontV1GetVersionAsync(options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.storefrontV1GetVersionAsync(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Lookup warehouses
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storefrontV1GetWarehousesAsync(options?: RawAxiosRequestConfig): AxiosPromise<Array<WebApiModulesIntegrationsStorefrontLocationModel>> {
            return localVarFp.storefrontV1GetWarehousesAsync(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get products in a catalog.
         * @param {string} catalogid 
         * @param {string} warehouseid 
         * @param {string} locationid 
         * @param {number} [pageno] 
         * @param {number} [pagesize] 
         * @param {string} [sort] 
         * @param {Array<FwStandardModelsFwQueryFilter>} [filter] 
         * @param {string} [inventorydepartmentid] 
         * @param {string} [categoryid] 
         * @param {string} [subcategoryid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storefrontV1GetWebCatalogProductsAsync(catalogid: string, warehouseid: string, locationid: string, pageno?: number, pagesize?: number, sort?: string, filter?: Array<FwStandardModelsFwQueryFilter>, inventorydepartmentid?: string, categoryid?: string, subcategoryid?: string, options?: RawAxiosRequestConfig): AxiosPromise<FwStandardModelsFwQueryResponseWebApiModulesIntegrationsStorefrontStorefrontProductLoader> {
            return localVarFp.storefrontV1GetWebCatalogProductsAsync(catalogid, warehouseid, locationid, pageno, pagesize, sort, filter, inventorydepartmentid, categoryid, subcategoryid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get products by id with availability.  (for revalidating shopping cart)
         * @param {string} productids 
         * @param {string} locationid 
         * @param {string} warehouseid 
         * @param {string} fromdate 
         * @param {string} todate 
         * @param {number} [pageno] 
         * @param {number} [pagesize] 
         * @param {string} [sort] 
         * @param {Array<FwStandardModelsFwQueryFilter>} [filter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storefrontV1GetWebCatalogProductsByIdWithAvailabilityAsync(productids: string, locationid: string, warehouseid: string, fromdate: string, todate: string, pageno?: number, pagesize?: number, sort?: string, filter?: Array<FwStandardModelsFwQueryFilter>, options?: RawAxiosRequestConfig): AxiosPromise<FwStandardModelsFwQueryResponseWebApiModulesIntegrationsStorefrontStorefrontProductLoader> {
            return localVarFp.storefrontV1GetWebCatalogProductsByIdWithAvailabilityAsync(productids, locationid, warehouseid, fromdate, todate, pageno, pagesize, sort, filter, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get products by comma separated list of InventoryIds with availability.   (When a product is removed from a catalog the catalog\'s product id will change, so we can query this endpoint to update the product ids in a users shopping cart if we can find the same InventoryId on a different catalog listing.
         * @param {string} inventoryids 
         * @param {string} locationid 
         * @param {string} warehouseid 
         * @param {string} fromdate 
         * @param {string} todate 
         * @param {number} [pageno] 
         * @param {number} [pagesize] 
         * @param {string} [sort] 
         * @param {Array<FwStandardModelsFwQueryFilter>} [filter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storefrontV1GetWebCatalogProductsByInventoryIdsWithAvailabilityAsync(inventoryids: string, locationid: string, warehouseid: string, fromdate: string, todate: string, pageno?: number, pagesize?: number, sort?: string, filter?: Array<FwStandardModelsFwQueryFilter>, options?: RawAxiosRequestConfig): AxiosPromise<FwStandardModelsFwQueryResponseWebApiModulesIntegrationsStorefrontStorefrontProductLoader> {
            return localVarFp.storefrontV1GetWebCatalogProductsByInventoryIdsWithAvailabilityAsync(inventoryids, locationid, warehouseid, fromdate, todate, pageno, pagesize, sort, filter, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get products in a catalog with availability.
         * @param {string} catalogid 
         * @param {string} locationid 
         * @param {string} warehouseid 
         * @param {string} fromdate 
         * @param {string} todate 
         * @param {number} [pageno] 
         * @param {number} [pagesize] 
         * @param {string} [sort] 
         * @param {Array<FwStandardModelsFwQueryFilter>} [filter] 
         * @param {string} [inventorydepartmentid] 
         * @param {string} [categoryid] 
         * @param {string} [subcategoryid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storefrontV1GetWebCatalogProductsWithAvailabilityAsync(catalogid: string, locationid: string, warehouseid: string, fromdate: string, todate: string, pageno?: number, pagesize?: number, sort?: string, filter?: Array<FwStandardModelsFwQueryFilter>, inventorydepartmentid?: string, categoryid?: string, subcategoryid?: string, options?: RawAxiosRequestConfig): AxiosPromise<FwStandardModelsFwQueryResponseWebApiModulesIntegrationsStorefrontStorefrontProductLoader> {
            return localVarFp.storefrontV1GetWebCatalogProductsWithAvailabilityAsync(catalogid, locationid, warehouseid, fromdate, todate, pageno, pagesize, sort, filter, inventorydepartmentid, categoryid, subcategoryid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Login (for Contacts)
         * @param {WebApiModulesIntegrationsStorefrontLoginRequest} [webApiModulesIntegrationsStorefrontLoginRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storefrontV1LoginAsync(webApiModulesIntegrationsStorefrontLoginRequest?: WebApiModulesIntegrationsStorefrontLoginRequest, options?: RawAxiosRequestConfig): AxiosPromise<WebApiModulesIntegrationsPortalAuthSvcLoginResponseDto> {
            return localVarFp.storefrontV1LoginAsync(webApiModulesIntegrationsStorefrontLoginRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Logout (for Contacts)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storefrontV1LogoutAsync(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.storefrontV1LogoutAsync(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns a list of items in the Storefront shopping cart format based on items in an order
         * @param {string} [orderId] 
         * @param {string} [webCatalogId] 
         * @param {string} [fromDate] 
         * @param {string} [toDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storefrontV1OrderToShoppingCartItemsAsync(orderId?: string, webCatalogId?: string, fromDate?: string, toDate?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<ShoppingCartItemDto>> {
            return localVarFp.storefrontV1OrderToShoppingCartItemsAsync(orderId, webCatalogId, fromDate, toDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Register a new account (Contact)
         * @param {WebApiModulesIntegrationsStorefrontContactRegistrationRequest} [webApiModulesIntegrationsStorefrontContactRegistrationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storefrontV1RegisterAsync(webApiModulesIntegrationsStorefrontContactRegistrationRequest?: WebApiModulesIntegrationsStorefrontContactRegistrationRequest, options?: RawAxiosRequestConfig): AxiosPromise<WebApiModulesIntegrationsStorefrontContactRegistrationResponse> {
            return localVarFp.storefrontV1RegisterAsync(webApiModulesIntegrationsStorefrontContactRegistrationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Renders an order report and returns a URL to the PDF.
         * @param {string} [orderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storefrontV1RenderOrderPdfAsync(orderId?: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.storefrontV1RenderOrderPdfAsync(orderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Renders a quote report and returns a URL to the PDF.
         * @param {string} [quoteId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storefrontV1RenderQuotePdfAsync(quoteId?: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.storefrontV1RenderQuotePdfAsync(quoteId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Send email to Reset Password (for Contacts)
         * @param {WebApiModulesIntegrationsStorefrontResetPasswordFromEmailRequest} [webApiModulesIntegrationsStorefrontResetPasswordFromEmailRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storefrontV1ResetPasswordFromEmailAsync(webApiModulesIntegrationsStorefrontResetPasswordFromEmailRequest?: WebApiModulesIntegrationsStorefrontResetPasswordFromEmailRequest, options?: RawAxiosRequestConfig): AxiosPromise<WebApiModulesIntegrationsPortalAuthSvcLoginResponseDto> {
            return localVarFp.storefrontV1ResetPasswordFromEmailAsync(webApiModulesIntegrationsStorefrontResetPasswordFromEmailRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Send email to Change Password (for Contacts)
         * @param {WebApiModulesIntegrationsStorefrontSendResetPasswordEmailRequest} [webApiModulesIntegrationsStorefrontSendResetPasswordEmailRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storefrontV1SendChangePasswordEmailAsync(webApiModulesIntegrationsStorefrontSendResetPasswordEmailRequest?: WebApiModulesIntegrationsStorefrontSendResetPasswordEmailRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.storefrontV1SendChangePasswordEmailAsync(webApiModulesIntegrationsStorefrontSendResetPasswordEmailRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Send an inquiry email about an item.
         * @param {WebApiModulesIntegrationsStorefrontSendInquiryEmailRequest} [webApiModulesIntegrationsStorefrontSendInquiryEmailRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storefrontV1SendInquiryEmailRequestAsync(webApiModulesIntegrationsStorefrontSendInquiryEmailRequest?: WebApiModulesIntegrationsStorefrontSendInquiryEmailRequest, options?: RawAxiosRequestConfig): AxiosPromise<WebApiModulesIntegrationsStorefrontSendInquiryEmailResponse> {
            return localVarFp.storefrontV1SendInquiryEmailRequestAsync(webApiModulesIntegrationsStorefrontSendInquiryEmailRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Send email to Reset Password (for Contacts)
         * @param {WebApiModulesIntegrationsStorefrontSendResetPasswordEmailRequest} [webApiModulesIntegrationsStorefrontSendResetPasswordEmailRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storefrontV1SendResetPasswordEmailAsync(webApiModulesIntegrationsStorefrontSendResetPasswordEmailRequest?: WebApiModulesIntegrationsStorefrontSendResetPasswordEmailRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.storefrontV1SendResetPasswordEmailAsync(webApiModulesIntegrationsStorefrontSendResetPasswordEmailRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Submit a Quote Request
         * @param {WebApiModulesIntegrationsStorefrontQuoteRequest} [webApiModulesIntegrationsStorefrontQuoteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storefrontV1SubmitQuoteRequestAsync(webApiModulesIntegrationsStorefrontQuoteRequest?: WebApiModulesIntegrationsStorefrontQuoteRequest, options?: RawAxiosRequestConfig): AxiosPromise<WebApiModulesIntegrationsStorefrontSubmitQuoteRequestResponse> {
            return localVarFp.storefrontV1SubmitQuoteRequestAsync(webApiModulesIntegrationsStorefrontQuoteRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StorefrontApi - object-oriented interface
 */
export class StorefrontApi extends BaseAPI {
    /**
     * 
     * @summary Login with Azure/Entra ID (for Contacts)
     * @param {WebApiModulesAccountServicesJwtAzureADRequest} [webApiModulesAccountServicesJwtAzureADRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public storefrontV1AzureLoginAsync(webApiModulesAccountServicesJwtAzureADRequest?: WebApiModulesAccountServicesJwtAzureADRequest, options?: RawAxiosRequestConfig) {
        return StorefrontApiFp(this.configuration).storefrontV1AzureLoginAsync(webApiModulesAccountServicesJwtAzureADRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get availability calendar data.
     * @param {string} inventoryId 
     * @param {string} warehouseId 
     * @param {string} fromDate 
     * @param {string} toDate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public storefrontV1GetAvailabilityCalendarAsync(inventoryId: string, warehouseId: string, fromDate: string, toDate: string, options?: RawAxiosRequestConfig) {
        return StorefrontApiFp(this.configuration).storefrontV1GetAvailabilityCalendarAsync(inventoryId, warehouseId, fromDate, toDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get catalog by id.
     * @param {string} catalogid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public storefrontV1GetCatalogByIdAsync(catalogid: string, options?: RawAxiosRequestConfig) {
        return StorefrontApiFp(this.configuration).storefrontV1GetCatalogByIdAsync(catalogid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get catalogs.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public storefrontV1GetCatalogsAsync(options?: RawAxiosRequestConfig) {
        return StorefrontApiFp(this.configuration).storefrontV1GetCatalogsAsync(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get categorytree for a catalog.
     * @param {string} catalogid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public storefrontV1GetCategoryTreeAsync(catalogid: string, options?: RawAxiosRequestConfig) {
        return StorefrontApiFp(this.configuration).storefrontV1GetCategoryTreeAsync(catalogid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Lookup a list of valid deals for submitting quote requests
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public storefrontV1GetDealAsync(options?: RawAxiosRequestConfig) {
        return StorefrontApiFp(this.configuration).storefrontV1GetDealAsync(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get resolved RentalWorks holidays in a date range.
     * @param {string} [fromDate]
     * @param {string} [toDate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public storefrontV1GetHolidaysAsync(fromDate?: string, toDate?: string, options?: RawAxiosRequestConfig) {
        return StorefrontApiFp(this.configuration).storefrontV1GetHolidaysAsync(fromDate, toDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Lookup locations for a warehouse
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public storefrontV1GetLocationsAsync(options?: RawAxiosRequestConfig) {
        return StorefrontApiFp(this.configuration).storefrontV1GetLocationsAsync(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns a list of Deals that the Contact is a member of.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public storefrontV1GetMyDealsAsync(options?: RawAxiosRequestConfig) {
        return StorefrontApiFp(this.configuration).storefrontV1GetMyDealsAsync(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get orders for a contact\'s deal (in the api token).
     * @param {number} [pageno] 
     * @param {number} [pagesize] 
     * @param {string} [sort] 
     * @param {Array<FwStandardModelsFwQueryFilter>} [filter] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public storefrontV1GetOrdersAsync(pageno?: number, pagesize?: number, sort?: string, filter?: Array<FwStandardModelsFwQueryFilter>, options?: RawAxiosRequestConfig) {
        return StorefrontApiFp(this.configuration).storefrontV1GetOrdersAsync(pageno, pagesize, sort, filter, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get product details of a single product, availability will be defaulted to today + 6 days and use the location/warehouse from the product\'s catalog.
     * @param {string} productid 
     * @param {string} warehouseid 
     * @param {string} locationid 
     * @param {string} fromdate 
     * @param {string} todate 
     * @param {number} [pageno] 
     * @param {number} [pagesize] 
     * @param {string} [sort] 
     * @param {Array<FwStandardModelsFwQueryFilter>} [filter] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public storefrontV1GetProductAsync(productid: string, warehouseid: string, locationid: string, fromdate: string, todate: string, pageno?: number, pagesize?: number, sort?: string, filter?: Array<FwStandardModelsFwQueryFilter>, options?: RawAxiosRequestConfig) {
        return StorefrontApiFp(this.configuration).storefrontV1GetProductAsync(productid, warehouseid, locationid, fromdate, todate, pageno, pagesize, sort, filter, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} inventoryid 
     * @param {string} warehouseid 
     * @param {string} fromdate 
     * @param {string} todate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public storefrontV1GetProductAvailabilityAsync(inventoryid: string, warehouseid: string, fromdate: string, todate: string, options?: RawAxiosRequestConfig) {
        return StorefrontApiFp(this.configuration).storefrontV1GetProductAvailabilityAsync(inventoryid, warehouseid, fromdate, todate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get extended product details with availability and rates
     * @param {string} productid 
     * @param {string} locationid 
     * @param {string} warehouseid 
     * @param {string} fromdate 
     * @param {string} todate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public storefrontV1GetProductDetailsAsync(productid: string, locationid: string, warehouseid: string, fromdate: string, todate: string, options?: RawAxiosRequestConfig) {
        return StorefrontApiFp(this.configuration).storefrontV1GetProductDetailsAsync(productid, locationid, warehouseid, fromdate, todate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the current status from a progress meter session.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public storefrontV1GetProgressMeterAsync(id: string, options?: RawAxiosRequestConfig) {
        return StorefrontApiFp(this.configuration).storefrontV1GetProgressMeterAsync(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the authenticated Storefront session.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public storefrontV1GetSessionAsync(options?: RawAxiosRequestConfig) {
        return StorefrontApiFp(this.configuration).storefrontV1GetSessionAsync(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns storefront settings.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public storefrontV1GetStorefrontSettingsAsync(options?: RawAxiosRequestConfig) {
        return StorefrontApiFp(this.configuration).storefrontV1GetStorefrontSettingsAsync(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns storefront settings.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public storefrontV1GetStorefrontSettingsSchemaAsync(options?: RawAxiosRequestConfig) {
        return StorefrontApiFp(this.configuration).storefrontV1GetStorefrontSettingsSchemaAsync(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the storefront api version.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public storefrontV1GetVersionAsync(options?: RawAxiosRequestConfig) {
        return StorefrontApiFp(this.configuration).storefrontV1GetVersionAsync(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Lookup warehouses
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public storefrontV1GetWarehousesAsync(options?: RawAxiosRequestConfig) {
        return StorefrontApiFp(this.configuration).storefrontV1GetWarehousesAsync(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get products in a catalog.
     * @param {string} catalogid 
     * @param {string} warehouseid 
     * @param {string} locationid 
     * @param {number} [pageno] 
     * @param {number} [pagesize] 
     * @param {string} [sort] 
     * @param {Array<FwStandardModelsFwQueryFilter>} [filter] 
     * @param {string} [inventorydepartmentid] 
     * @param {string} [categoryid] 
     * @param {string} [subcategoryid] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public storefrontV1GetWebCatalogProductsAsync(catalogid: string, warehouseid: string, locationid: string, pageno?: number, pagesize?: number, sort?: string, filter?: Array<FwStandardModelsFwQueryFilter>, inventorydepartmentid?: string, categoryid?: string, subcategoryid?: string, options?: RawAxiosRequestConfig) {
        return StorefrontApiFp(this.configuration).storefrontV1GetWebCatalogProductsAsync(catalogid, warehouseid, locationid, pageno, pagesize, sort, filter, inventorydepartmentid, categoryid, subcategoryid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get products by id with availability.  (for revalidating shopping cart)
     * @param {string} productids 
     * @param {string} locationid 
     * @param {string} warehouseid 
     * @param {string} fromdate 
     * @param {string} todate 
     * @param {number} [pageno] 
     * @param {number} [pagesize] 
     * @param {string} [sort] 
     * @param {Array<FwStandardModelsFwQueryFilter>} [filter] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public storefrontV1GetWebCatalogProductsByIdWithAvailabilityAsync(productids: string, locationid: string, warehouseid: string, fromdate: string, todate: string, pageno?: number, pagesize?: number, sort?: string, filter?: Array<FwStandardModelsFwQueryFilter>, options?: RawAxiosRequestConfig) {
        return StorefrontApiFp(this.configuration).storefrontV1GetWebCatalogProductsByIdWithAvailabilityAsync(productids, locationid, warehouseid, fromdate, todate, pageno, pagesize, sort, filter, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get products by comma separated list of InventoryIds with availability.   (When a product is removed from a catalog the catalog\'s product id will change, so we can query this endpoint to update the product ids in a users shopping cart if we can find the same InventoryId on a different catalog listing.
     * @param {string} inventoryids 
     * @param {string} locationid 
     * @param {string} warehouseid 
     * @param {string} fromdate 
     * @param {string} todate 
     * @param {number} [pageno] 
     * @param {number} [pagesize] 
     * @param {string} [sort] 
     * @param {Array<FwStandardModelsFwQueryFilter>} [filter] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public storefrontV1GetWebCatalogProductsByInventoryIdsWithAvailabilityAsync(inventoryids: string, locationid: string, warehouseid: string, fromdate: string, todate: string, pageno?: number, pagesize?: number, sort?: string, filter?: Array<FwStandardModelsFwQueryFilter>, options?: RawAxiosRequestConfig) {
        return StorefrontApiFp(this.configuration).storefrontV1GetWebCatalogProductsByInventoryIdsWithAvailabilityAsync(inventoryids, locationid, warehouseid, fromdate, todate, pageno, pagesize, sort, filter, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get products in a catalog with availability.
     * @param {string} catalogid 
     * @param {string} locationid 
     * @param {string} warehouseid 
     * @param {string} fromdate 
     * @param {string} todate 
     * @param {number} [pageno] 
     * @param {number} [pagesize] 
     * @param {string} [sort] 
     * @param {Array<FwStandardModelsFwQueryFilter>} [filter] 
     * @param {string} [inventorydepartmentid] 
     * @param {string} [categoryid] 
     * @param {string} [subcategoryid] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public storefrontV1GetWebCatalogProductsWithAvailabilityAsync(catalogid: string, locationid: string, warehouseid: string, fromdate: string, todate: string, pageno?: number, pagesize?: number, sort?: string, filter?: Array<FwStandardModelsFwQueryFilter>, inventorydepartmentid?: string, categoryid?: string, subcategoryid?: string, options?: RawAxiosRequestConfig) {
        return StorefrontApiFp(this.configuration).storefrontV1GetWebCatalogProductsWithAvailabilityAsync(catalogid, locationid, warehouseid, fromdate, todate, pageno, pagesize, sort, filter, inventorydepartmentid, categoryid, subcategoryid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Login (for Contacts)
     * @param {WebApiModulesIntegrationsStorefrontLoginRequest} [webApiModulesIntegrationsStorefrontLoginRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public storefrontV1LoginAsync(webApiModulesIntegrationsStorefrontLoginRequest?: WebApiModulesIntegrationsStorefrontLoginRequest, options?: RawAxiosRequestConfig) {
        return StorefrontApiFp(this.configuration).storefrontV1LoginAsync(webApiModulesIntegrationsStorefrontLoginRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Logout (for Contacts)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public storefrontV1LogoutAsync(options?: RawAxiosRequestConfig) {
        return StorefrontApiFp(this.configuration).storefrontV1LogoutAsync(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns a list of items in the Storefront shopping cart format based on items in an order
     * @param {string} [orderId] 
     * @param {string} [webCatalogId] 
     * @param {string} [fromDate] 
     * @param {string} [toDate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public storefrontV1OrderToShoppingCartItemsAsync(orderId?: string, webCatalogId?: string, fromDate?: string, toDate?: string, options?: RawAxiosRequestConfig) {
        return StorefrontApiFp(this.configuration).storefrontV1OrderToShoppingCartItemsAsync(orderId, webCatalogId, fromDate, toDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Register a new account (Contact)
     * @param {WebApiModulesIntegrationsStorefrontContactRegistrationRequest} [webApiModulesIntegrationsStorefrontContactRegistrationRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public storefrontV1RegisterAsync(webApiModulesIntegrationsStorefrontContactRegistrationRequest?: WebApiModulesIntegrationsStorefrontContactRegistrationRequest, options?: RawAxiosRequestConfig) {
        return StorefrontApiFp(this.configuration).storefrontV1RegisterAsync(webApiModulesIntegrationsStorefrontContactRegistrationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Renders an order report and returns a URL to the PDF.
     * @param {string} [orderId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public storefrontV1RenderOrderPdfAsync(orderId?: string, options?: RawAxiosRequestConfig) {
        return StorefrontApiFp(this.configuration).storefrontV1RenderOrderPdfAsync(orderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Renders a quote report and returns a URL to the PDF.
     * @param {string} [quoteId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public storefrontV1RenderQuotePdfAsync(quoteId?: string, options?: RawAxiosRequestConfig) {
        return StorefrontApiFp(this.configuration).storefrontV1RenderQuotePdfAsync(quoteId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Send email to Reset Password (for Contacts)
     * @param {WebApiModulesIntegrationsStorefrontResetPasswordFromEmailRequest} [webApiModulesIntegrationsStorefrontResetPasswordFromEmailRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public storefrontV1ResetPasswordFromEmailAsync(webApiModulesIntegrationsStorefrontResetPasswordFromEmailRequest?: WebApiModulesIntegrationsStorefrontResetPasswordFromEmailRequest, options?: RawAxiosRequestConfig) {
        return StorefrontApiFp(this.configuration).storefrontV1ResetPasswordFromEmailAsync(webApiModulesIntegrationsStorefrontResetPasswordFromEmailRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Send email to Change Password (for Contacts)
     * @param {WebApiModulesIntegrationsStorefrontSendResetPasswordEmailRequest} [webApiModulesIntegrationsStorefrontSendResetPasswordEmailRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public storefrontV1SendChangePasswordEmailAsync(webApiModulesIntegrationsStorefrontSendResetPasswordEmailRequest?: WebApiModulesIntegrationsStorefrontSendResetPasswordEmailRequest, options?: RawAxiosRequestConfig) {
        return StorefrontApiFp(this.configuration).storefrontV1SendChangePasswordEmailAsync(webApiModulesIntegrationsStorefrontSendResetPasswordEmailRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Send an inquiry email about an item.
     * @param {WebApiModulesIntegrationsStorefrontSendInquiryEmailRequest} [webApiModulesIntegrationsStorefrontSendInquiryEmailRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public storefrontV1SendInquiryEmailRequestAsync(webApiModulesIntegrationsStorefrontSendInquiryEmailRequest?: WebApiModulesIntegrationsStorefrontSendInquiryEmailRequest, options?: RawAxiosRequestConfig) {
        return StorefrontApiFp(this.configuration).storefrontV1SendInquiryEmailRequestAsync(webApiModulesIntegrationsStorefrontSendInquiryEmailRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Send email to Reset Password (for Contacts)
     * @param {WebApiModulesIntegrationsStorefrontSendResetPasswordEmailRequest} [webApiModulesIntegrationsStorefrontSendResetPasswordEmailRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public storefrontV1SendResetPasswordEmailAsync(webApiModulesIntegrationsStorefrontSendResetPasswordEmailRequest?: WebApiModulesIntegrationsStorefrontSendResetPasswordEmailRequest, options?: RawAxiosRequestConfig) {
        return StorefrontApiFp(this.configuration).storefrontV1SendResetPasswordEmailAsync(webApiModulesIntegrationsStorefrontSendResetPasswordEmailRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Submit a Quote Request
     * @param {WebApiModulesIntegrationsStorefrontQuoteRequest} [webApiModulesIntegrationsStorefrontQuoteRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public storefrontV1SubmitQuoteRequestAsync(webApiModulesIntegrationsStorefrontQuoteRequest?: WebApiModulesIntegrationsStorefrontQuoteRequest, options?: RawAxiosRequestConfig) {
        return StorefrontApiFp(this.configuration).storefrontV1SubmitQuoteRequestAsync(webApiModulesIntegrationsStorefrontQuoteRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
